// extracted by mini-css-extract-plugin
export default {"contentContainer":"WzoMY","fullOpacity":"OHQ2R","content":"ngHId","triangleWrapper":"VFxJ0","top":"m-NBq","right":"yHFMr","left":"hiMpS","bottom":"mWK4S","triangle":"T4Xdd"};